import React, { useState } from "react";
import { BsDownload } from "react-icons/bs";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { useDisclosure } from "@chakra-ui/react";
import { CiCalendarDate } from "react-icons/ci";
import ExpertPriceDrawer from "../Drawer/ExpertPriceDrawer";
import MonthYearDrawer from "../Drawer/MonthYearDrawer";
import { MonthYearModal } from "../Modals/DownloadBillingPdfModal";
import { IoIosSend } from "react-icons/io";
import { InvoiceMonthModal } from "../Modals/InvoiceNotificationModal";

export const ExpertPriceList = ({ data, func }: any) => {
  const { onOpen, isOpen, onClose } = useDisclosure();
  const { photograph_link, full_name, role, app_info, prices, billing_month } =
    data.data;
  const [drawer, setDrawer] = useState("");
  const enableMonth = ( array:[]) => {
 return array.filter((el:any)=>el.enabled)
  }
  return (
    <div className="col-md-12  expert-pricing-lower-div mb-2 ml-2">
      <div className="our-team expert_div">
        <div className="pic">
          <img
            src={photograph_link ? photograph_link : "/img/avtar.png"}
            alt=""
          />
        </div>
        <div className="team-content">
          <h3 className="title">{full_name}</h3>
          <span className="post">{role}</span>
        </div>
        <ul className="social">
          <li>
            <a>
              <CiCalendarDate
                onClick={() => {
                  setDrawer("billingmonth");
                  onOpen();
                }}
              />
            </a>
          </li>
          <li>
            <a>
              <HiOutlineCurrencyRupee
                onClick={() => {
                  setDrawer("expertprice");
                  onOpen();
                }}
              />
            </a>
          </li>
          <li>
            <a>
              <BsDownload
                onClick={() => {
                  setDrawer("downloadpdf");
                  onOpen();
                }}
              />
            </a>
          </li>
          <li>
            <a>
              <IoIosSend
                onClick={() => {
                  setDrawer("sendInvoiceNotifiction");
                  onOpen();
                }}
              />
            </a>
          </li>
        </ul>
      </div>
      {drawer === "downloadpdf" && (
        <MonthYearModal
          isOpen={isOpen}
          onClose={onClose}
          data={enableMonth(billing_month)}
          id={data._id}
          name={full_name}

        />
      )}
      {drawer === "sendInvoiceNotifiction" && (
        <InvoiceMonthModal
          isOpen={isOpen}
          onClose={onClose}
          data={enableMonth(billing_month)}
          id={data._id}
          isNotification={true}
        />
      )}
      {drawer === "expertprice" && (
        <ExpertPriceDrawer
          isOpen={isOpen}
          onClose={onClose}
          data={prices}
          id={data._id}
        />
      )}
      {drawer === "billingmonth" && (
        <MonthYearDrawer
          isOpen={isOpen}
          onClose={onClose}
          data={billing_month}
          id={data._id}
          func={func}
        />
      )}
    </div>
  );
};
